import { Loading, Table, Text } from '@/components';
import { OrganizationName } from '@/features/tenant-manager/organization/_components/OrganizationName';
import { useId } from '@/hooks';
import { transformToDataWithChildren } from '@/utils';
import { useTranslation } from 'react-i18next';
import { useOrganizationsSnapshot } from '../_hooks/organizations-snapshot';
import { useOrganizationsSnapshotQueryState } from '../_hooks/organizations-snapshot-query-state';

export const OrganizationsTable = () => {
  const { id } = useId();
  const { t } = useTranslation();
  const { searchQueryStates, setSearchQueryStates } =
    useOrganizationsSnapshotQueryState();
  const flatOrganizations = useOrganizationsSnapshot({
    id,
    params: searchQueryStates,
  });

  return flatOrganizations.isPending ? (
    <Loading height="60vh" />
  ) : (
    <Table
      enableSticky
      rowKey="id"
      dataSource={transformToDataWithChildren(
        flatOrganizations.data?.results ?? [],
      )}
      pagination={{
        current: searchQueryStates.page,
        pageSize: searchQueryStates.pageSize,
        total: flatOrganizations.data?.count,
        onChange: (page, pageSize) => {
          setSearchQueryStates((pre) => ({ ...pre, page, pageSize }));
        },
      }}
      columns={[
        {
          title: t('organization-code'),
          dataIndex: 'code',
          width: 400,
          render: (_, { code }) => {
            return <Text weight="regular" text={code} />;
          },
        },
        {
          title: t('name'),
          dataIndex: 'name',
          render: (_, { name, isIntegrated, isExcludedFromOptions }) => (
            <OrganizationName
              name={name}
              isIntegrated={isIntegrated}
              isExcludedFromOptions={isExcludedFromOptions}
            />
          ),
        },
      ]}
    />
  );
};
